export const NavigationEnum = Object.freeze({
    MUSTER_ARTICLE: "MUSTER_ARTICLE",
    MUSTER_CHECKLIST: "MUSTER_CHECKLIST",
    MUSTER_OVERVIEW: "MUSTER_OVERVIEW",
});
